import React from 'react';
import CusPageCardContainer from '../../../components/shared/CusPageCardContainer';
import HistoryMailingContent from './HistoryMailingContent';

export default function HistoryMailing() {
  return (
    <CusPageCardContainer title={'Mailing history'}>
      <HistoryMailingContent />
    </CusPageCardContainer>
  );
}
